import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { LoginComponent } from './features/auth/login/login.component';
import { RegisterComponent } from './features/auth/register/register.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { ContactPageComponent } from './features/public-pages/contact-page/contact-page.component';
import { FlowPageComponent } from './features/public-pages/flow-page/flow-page.component';
import { HomeAlternativeComponent } from './features/public-pages/home-alternative/home-alternative.component';
import { SolutionsComponent } from './features/public-pages/solutions/solutions.component';

export const routes: Routes = [
  { path: '', component: HomeAlternativeComponent },
  { path: 'soluzioni', component: SolutionsComponent },
  { path: 'come-funziona', component: FlowPageComponent },
  { path: 'demo', component: ContactPageComponent },
  { path: 'login', component: LoginComponent },
  { path: 'registrazione', component: RegisterComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
  { path: '**', redirectTo: '' }
];
